module.exports = __webpack_public_path__ + "img/basketball.166c9e3f.svg";